import { defineStore } from "pinia";
import axios from "axios";
import { initClient } from "rdep-ecom-sdk";

export const useAppStore = defineStore("app", {
  state: () => ({
    domainName: "",
    baseUrl: "",
    tenantApiBaseUrl: "",
    receiptUrl: "",
    tenantSubDomain: "",
    tenantDetails: null,
  }),

  getters: {
    tenantLogoUrl: (state) => {
      const details = state.tenantDetails || {};
      const logoUrl =
        details.logoUrl ||
        details.logoURL ||
        details.tenant?.logoUrl ||
        details.tenant?.logoURL ||
        "";

      return String(logoUrl || "").trim();
    },
  },

  actions: {
    initializeDomainConfig() {
      const currentHost = String(window.location.host || "").trim();
      const isLocalHost = /^(localhost|127\.0\.0\.1)(:\d+)?$/i.test(
        currentHost,
      );

      const fallbackDomainName = isLocalHost
        ? "ecom-retail.qa.rdep.io"
        : currentHost;
      const fallbackApiBaseUrl = isLocalHost
        ? "https://app-qa.rdep.io"
        : `${window.location.protocol}//${window.location.host}`;

      this.domainName = process.env.VUE_APP_DOMAIN_NAME || fallbackDomainName;
      this.baseUrl = process.env.VUE_APP_BASE_URL || fallbackApiBaseUrl;
      this.tenantApiBaseUrl =
        process.env.VUE_APP_TENANT_API_BASE_URL || this.baseUrl;
      this.receiptUrl = process.env.VUE_APP_RECEIPT_URL || this.baseUrl;
      this.tenantSubDomain = this.getTenantSubDomain();

      axios.defaults.baseURL = this.baseUrl;
      initClient(this.tenantApiBaseUrl);
    },

    setTenantDetails(tenantDetails) {
      this.tenantDetails = tenantDetails || null;
    },

    getTenantSubDomain() {
      const host = window.location.host;
      const parts = host.split(".");
      const domainLength = 3;

      return parts.length >= domainLength && parts[0] !== "www"
        ? parts[0]
        : process.env.VUE_APP_SUB_DOMAIN || "";
    },
  },
});
